import { Input } from "@fullscreendigital/carrefour-dex-fe"
import { DownloadIcon } from "../../../../../../../icons"
import { format3 } from "./serializers"

export const toolbarActions = ({
 totalCount,
 exportFileExcel,
 isExcelExportLoading
}) => {
  if (!totalCount || totalCount <= 0) return []

  return [
    {
      label: isExcelExportLoading ? 'Export in curs...' : 'Export Excel',
      icon: <DownloadIcon />,
      onClick: isExcelExportLoading ? () => {} : exportFileExcel
    }
  ]
}

export const columns = [
  { title: 'ID', field: 'id', align: 'left', type: 'string',  width: '100px' },
  { title: 'Cod EAN', field: 'eanCode', align: 'left', type: 'string', width: '120px' },
  { title: 'Cod produs', field: 'articleCode', align: 'left', type: 'string', width: '120px' },
  { title: 'Nume produs', field: 'articleName', align: 'left', type: 'string', width: '120px' },
  { title: 'Cod scanat', field: 'scannedCode', align: 'left', type: 'string', width: '120px' },
  { title: 'Unitate de masura', field: 'measureUnit', align: 'left', type: 'string',  width: '100px' },
  { title: 'Numar PCB-uri', field: 'pcbNumber', align: 'left', type: 'string',  width: '100px' },
  { title: 'Numar produse in PCB', field: 'unitsPerLogisticUnit', align: 'left', type: 'string',  width: '100px' },
  { title: 'Cantitate asteptata', field: 'orderedQuantity', align: 'left', type: 'string',  width: '100px' },
  { title: 'Cantitate livrata/recepționată', field: 'receivedQuantity', align: 'left', type: 'string', width: '150px' },
  {
    title: 'Diferenta',
    field: 'difference',
    align: 'left',
    type: 'string',
    render: row => format3(row.differenceRaw),
    width: '100px'
  },
  { title: 'Data expirării', field: 'expirationDate', align: 'left', type: 'date',  width: '120px' },
  { title: 'Nr. linie comandă', field: 'orderLineNumber', align: 'left', type: 'numeric',  width: '100px' }
]

export const drawerFilters = () => [
  {
    name: 'eanCode',
    value: '',
    filter: <Input variant="outlined" label="Cod EAN" type="text" />,
    type: 'text',
    label: 'Cod EAN'
  },
  {
    name: 'articleCode',
    value: '',
    filter: <Input variant="outlined" label="Cod produs" type="text" />,
    type: 'text',
    label: 'Cod produs'
  },
  {
    name: 'scannedCode',
    value: '',
    filter: <Input variant="outlined" label="Cod scanat" type="text" />,
    type: 'text',
    label: 'Cod scanat'
  },
  {
    name: 'measureUnit',
    value: '',
    filter: <Input variant="outlined" label="Unitate de masura" type="text" />,
    type: 'text',
    label: 'Unitate de masura'
  },
]
